import React from "react";
import {useTranslation} from "react-i18next";

import WorkgroupCol from "../../../components/columns/WorkgroupCol";
import AclTable from "../../../components/AclTable";

import Card from "@mui/material/Card";

const permissions = ['users:read', 'users:write', 'incidents:write', 'data:validate', 'data:write']

export const WorkgroupPermissions = ({user}) => {
    const {t} = useTranslation("user");

    return <Card sx={{p: 2}}>
        <AclTable title={t('cardPermissions.workgroupTitle')}
                  principalType={"user"}
                  principalId={user.id}
                  resourcesType={"workgroup"}
                  permissions={permissions}
                  entityHeader={t('cardPermissions.table.workgroup')}
                  renderEntityCol={(workgroup) => <WorkgroupCol workgroup={workgroup}/>}
                  multipleCheck
                  entitySortFieldName="name"
                  dataTableProps={{canSearch: false, showTotalEntries: false, entriesPerPage: false}}
        />
    </Card>
}

export default WorkgroupPermissions;
